import { useMemo } from 'react'

import { type Option } from 'core/domain/Option'

import { useConfigContext } from 'config/ui/ConfigContext'

import type { Shipment } from '../../domain/Shipment'
import type { AccessorialOption } from '../../domain/ShipmentCharges'
import { formatStopName } from '../../presenters/shipmentChargePresenter'

export const noStopOption = {
  value: 'not-applicable',
  label: 'Not Applicable',
}

export function useShipmentChargeStopOptions({
  shipment,
  selectedAccessorial,
}: {
  shipment: Shipment
  selectedAccessorial: AccessorialOption | null
}) {
  const configs = useConfigContext()
  const enablePriceItemTypes = configs.enablePriceItemTypes.toBoolean()

  const stopOptions: Array<Option<string | number>> = useMemo(() => {
    if (!enablePriceItemTypes) {
      return [
        noStopOption,
        ...shipment.stops.map(stop => ({
          label: formatStopName(stop),
          value: stop.stopIndex,
        })),
      ]
    }

    if (selectedAccessorial) {
      const supportedStopTypes = selectedAccessorial.stopsRelationship

      if (!supportedStopTypes?.length) {
        return [noStopOption]
      }

      const supportedStops = shipment.stops.filter(stop =>
        supportedStopTypes.includes(stop.stopType)
      )

      return supportedStops.map(stop => ({
        label: formatStopName(stop),
        value: stop.stopIndex,
      }))
    }

    return [noStopOption]
  }, [shipment.stops, enablePriceItemTypes, selectedAccessorial])

  return { stopOptions }
}
